/**
 * URL query-param key that drives the active dashboard tab
 * (Lenses / Lenses 2 / General / Signals).
 *
 * Backed by useSearchParamsState so the active tab is reflected in the URL —
 * this lets any descendant widget deep-link / jump to another tab simply by
 * setting this param (e.g. the Signals widget's "Open in Signals Explorer"
 * button), without threading a callback down the tree.
 */
export const DASHBOARD_TAB_PARAM_KEY = "dashboardTab";
